module.exports = __webpack_public_path__ + "img/one_crew_onboard.56708bde.jpg";